import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@filadd/phi-plus-core";
export const Action = ({ label, url, onActed }) => (_jsx("a", { href: url, onClick: onActed, onAuxClick: onActed, children: _jsx(Button, { variant: "outline", size: "xs", type: "button", children: label }) }));
//# sourceMappingURL=Action.js.map